import { formatPhoneNumber } from 'helpers/phone-number'

export const formatPhoneNumbers = numbers => numbers.map(number => formatPhoneNumber(number))
